export class TagProfile {
    public id: string;
    public name: string;
    public expectedBatteryLife: string;
    public comments: string;
    public description: string;
    public intervalInMinutes: number;

    constructor(obj: any) {
        this.id = obj?.id;
        this.name = obj?.name;
        this.expectedBatteryLife = obj?.expectedBatteryLife;
        this.comments = obj?.comments;
        this.description = obj?.description;
        this.intervalInMinutes = obj?.intervalInMinutes;
    }
}
